import React, { useEffect, useState } from "react";
import "./card-book.scss";

import SharedModal from "../../molecules/share-modal-books/shareModalBooks";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { withPrefix } from "gatsby";

import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import DefaultImage from "../../../assets/images/not-found/Icono_vertical_portada_libro.jpg";

//href={`https://www.comfama.com/bibliotecas/libros/detalle/?book=${book.mmsId}`}

interface BookInterface {
  book: {
    titulo: string;
    origenContenido: string;
    autor: string;
    image: {
      title: string;
      file: {
        fileName: string;
        url: string;
      };
    };
    mmsId: string;
    tipoContenido: string;
  };
  gtmClass: string;
}

const CardBook = (props: BookInterface) => {
  const { window } = useBrowserMode();
  const { book } = props;

  const hrefUrl = book
    ? `https://www.comfama.com/bibliotecas/libros/detalle/?book=${book.mmsId}`
    : "";

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [imgError, setimgError] = useState(false);

  // const ellipsis = (desMobile) => {
  //   if (book.titulo.length > desMobile) {
  //     let truncate =
  //       book.titulo
  //         .trim()
  //         .substring(0, desMobile)
  //         .split(" ")
  //         .slice(0, -1)
  //         .join(" ") + "...";
  //     return truncate;
  //   } else {
  //     return book.titulo;
  //   }
  // };

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const handleErroImage = () => {
    setimgError(true);
  };

  useEffect(() => {
    window.addEventListener("load", () => {});
  }, []);

  // const [bookDigital] = useState(book.origenContenido === "digital") ;
  // const [physical] = useState(book.origenContenido === "physical");
  return (
    <div className="a-card">
      {book && (
        <>
          <div
            /*  className="a-card-content" */
            className={`"a-card-content"`}
          >
            <div className="a-card-content-img">
              <a
                href={`https://www.comfama.com/bibliotecas/libros/detalle/?book=${book.mmsId}`}
                target="_blank" rel="noreferrer"
              >
                <img
                  src={
                    book.image
                      ? imgError
                        ? DefaultImage
                        : book.image.file.url
                      : DefaultImage
                  }
                  alt={
                    book.image ? book.image.title : "Imagen resultado búsqueda"
                  }
                  onError={handleErroImage}
                  className={`${normalizeTwoWords(props.gtmClass)}`}
                  // src={author.img.ulr || DefaultImage}
                  // alt={author.img.desc || "Imagen resultado búsqueda"}
                />
                {book.tipoContenido && book.tipoContenido === "audiobook" && (
                  <div className="a-card-content-img-type">
                    <div className="content-icon">
                      <i className={"icon icon-headphones"} />
                    </div>
                  </div>
                )}
                {book.tipoContenido !== "audiobook" && book.origenContenido && (
                  <div className="a-card-content-img-type">
                    {book.origenContenido.includes("digital") && (
                      <div className="content-icon">
                        <i className={"icon icon-mobile-alt"} />
                      </div>
                    )}
                    {book.origenContenido.includes("physical") && (
                      <div className="content-icon">
                        <i className={"icon icon-book"} />
                      </div>
                    )}
                  </div>
                )}
              </a>
            </div>
            <div className="a-card-content__title-container">
              <h3 className="a-card-content-title hide-on-mobile">
                {book.titulo}
              </h3>
              <h3 className="a-card-content-title show-on-mobile">
                {book.titulo}
              </h3>
            </div>
            <p
              className="a-card-content-author"
              onClick={(e) => {
                e.stopPropagation();
                window.location.assign(
                  withPrefix(`/resultados-busqueda?search=${book.autor}`)
                );
              }}
            >
              {book.autor}
            </p>
            <span className="a-card-content-separator" />
            <div className="a-card-content-menu">
              <i
                className={
                  "icon icon-share gtmRedDeAmorHabitosMentalLibrosCompartir"
                }
                onClick={(e) => {
                  toggleModal();
                  e.stopPropagation();
                }}
              />
            </div>
          </div>
          <SharedModal
            open={isModalVisible}
            onClose={toggleModal}
            href={hrefUrl}
          />
        </>
      )}
    </div>
  );
};

export default CardBook;
